/**
 * Assuntos que o dono pode pedir pro Secretário acompanhar em "Notícias do
 * seu jeito". O server mapeia cada id pras fontes (newsSources.ts); o client
 * mostra o nome e o ícone 3D (`/news-topics/<id>.webp`).
 */
export const NEWS_TOPICS = [
    { id: 'principais', label: 'Principais do dia' },
    { id: 'tecnologia', label: 'Tecnologia' },
    { id: 'carros', label: 'Carros' },
    { id: 'dinheiro', label: 'Dinheiro' },
    { id: 'esportes', label: 'Esportes' },
    { id: 'politica', label: 'Política' },
    { id: 'mundo', label: 'Mundo' },
    { id: 'saude', label: 'Saúde' },
    { id: 'famosos', label: 'Famosos & TV' },
    { id: 'viagem', label: 'Viagem' },
];
// Ids da primeira versão (antes da lista acima), que podem estar salvos na
// config de quem já usou — continuam valendo, apontando pro assunto novo.
const LEGACY_TOPIC_ALIASES = {
    geral: 'principais',
    economia: 'dinheiro',
    entretenimento: 'famosos',
};
export function normalizeNewsTopic(value) {
    if (typeof value !== 'string')
        return null;
    if (NEWS_TOPICS.some((t) => t.id === value))
        return value;
    return LEGACY_TOPIC_ALIASES[value] ?? null;
}
export function newsTopicLabel(id) {
    return NEWS_TOPICS.find((t) => t.id === id)?.label ?? id;
}
